var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _c("div", [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { staticClass: "button-container" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-add-brand-subject",
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.handleCreate()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("brandSubject.addNewBrandSubject")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                data: _vm.list,
                "element-loading-text": "Loading...",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { align: "center", label: "ID", width: "95" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ $index }) {
                        return [_vm._v(_vm._s($index))]
                      },
                    },
                  ]),
                },
                [_vm._v(" an ")]
              ),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.consultSubjectName"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(" " + _vm._s(row.consultSubjectName) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.consultBrandName"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.consultBrandName) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.orderNo"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.orderNo) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.region"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        !row.region
                          ? _c("span", { staticClass: "all-countries-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("brandSubject.allCountries")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.splitRegions(row.region), function (code) {
                          return _c(
                            "el-tag",
                            {
                              key: code,
                              staticStyle: { margin: "2px" },
                              attrs: { size: "mini" },
                            },
                            [_vm._v(" " + _vm._s(code.toUpperCase()) + " ")]
                          )
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.isConsultFree"),
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isConsultFree
                          ? _c(
                              "el-button",
                              { attrs: { size: "mini", type: "success" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("brandSubject.free")) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "el-button",
                              { attrs: { size: "mini", type: "danger" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("brandSubject.paid")) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.state"),
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.isActive
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleBrandSubjectActive(
                                      row,
                                      false
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("brandSubject.active")) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleBrandSubjectActive(
                                      row,
                                      true
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("brandSubject.passive")) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("brandSubject.actions"),
                  align: "center",
                  "class-name": "fixed-width",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("brandSubject.edit")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.showDeleteConfirmation(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("brandSubject.delete")) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.textMap[_vm.dialogStatus],
                visible: _vm.dialogFormVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "dataForm",
                  staticStyle: { width: "400px", "margin-left": "50px" },
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.tempBrandSubjectData,
                    "label-position": "left",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("brandSubject.consultSubjectName"),
                        title: "Subject Name",
                        "label-width": "200px",
                        prop: "consultSubjectId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Select Subject" },
                          model: {
                            value: _vm.tempBrandSubjectData.consultSubjectId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.tempBrandSubjectData,
                                "consultSubjectId",
                                $$v
                              )
                            },
                            expression: "tempBrandSubjectData.consultSubjectId",
                          },
                        },
                        _vm._l(_vm.subjectOptions, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.label, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("brandSubject.consultBrandName"),
                        title: "Brand Name",
                        "label-width": "200px",
                        prop: "consultBrandId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Select Brand" },
                          model: {
                            value: _vm.tempBrandSubjectData.consultBrandId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.tempBrandSubjectData,
                                "consultBrandId",
                                $$v
                              )
                            },
                            expression: "tempBrandSubjectData.consultBrandId",
                          },
                        },
                        _vm._l(_vm.brandOptions, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.label, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("brandSubject.orderNo"),
                        "label-width": "200px",
                        prop: "orderNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "number", placeholder: "Order" },
                        model: {
                          value: _vm.tempBrandSubjectData.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.tempBrandSubjectData, "orderNo", $$v)
                          },
                          expression: "tempBrandSubjectData.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "isConsultFree",
                        label: _vm.$t("brandSubject.isConsultFree"),
                        "label-width": "200px",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "inline-prompt": "",
                          "active-text": _vm.$t("brandSubject.free"),
                          "inactive-text": _vm.$t("brandSubject.paid"),
                        },
                        model: {
                          value: _vm.tempBrandSubjectData.isConsultFree,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tempBrandSubjectData,
                              "isConsultFree",
                              $$v
                            )
                          },
                          expression: "tempBrandSubjectData.isConsultFree",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "isActive",
                        label: _vm.$t("brandSubject.state"),
                        "label-width": "200px",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "inline-prompt": "",
                          "active-text": _vm.$t("brandSubject.active"),
                          "inactive-text": _vm.$t("brandSubject.passive"),
                        },
                        model: {
                          value: _vm.tempBrandSubjectData.isActive,
                          callback: function ($$v) {
                            _vm.$set(_vm.tempBrandSubjectData, "isActive", $$v)
                          },
                          expression: "tempBrandSubjectData.isActive",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("brandSubject.region"),
                        "label-width": "200px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            clearable: "",
                            placeholder: _vm.$t(
                              "brandSubject.regionPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.tempRegions,
                            callback: function ($$v) {
                              _vm.tempRegions = $$v
                            },
                            expression: "tempRegions",
                          },
                        },
                        _vm._l(_vm.applicationRegions, function (option) {
                          return _c("el-option", {
                            key: option,
                            attrs: {
                              label: option.toUpperCase(),
                              value: option,
                            },
                          })
                        }),
                        1
                      ),
                      _c("div", { staticClass: "region-hint" }, [
                        _vm._v(_vm._s(_vm.$t("brandSubject.regionHint"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.cancel")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.dialogStatus === "create"
                            ? _vm.createData()
                            : _vm.updateData()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Delete Item",
                visible: _vm.deleteConfirmationVisible,
                width: "30%",
                "before-close": _vm.handleDeleteConfirmationClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.deleteConfirmationVisible = $event
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("brandSubject.deletePopup")))]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.deleteConfirmationVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("brandSubject.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.deleteItem },
                    },
                    [_vm._v(_vm._s(_vm.$t("brandSubject.ok")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }